<template>
    <el-card>
        <el-row>
            <el-form :model="form" :inline="true" ref="form" label-width="auto" size="small" :rules="{}">
                <el-form-item prop="comment" :label="$t('momoLogs.comment')">
                    <el-input size="mini" v-model="form.comment" />
                </el-form-item>
                <el-form-item prop="merchantOrderNo" :label="$t('momoLogs.merchantOrderNo')">
                    <el-input size="mini" v-model="form.merchantOrderNo" />
                </el-form-item>
                <el-form-item prop="systemOrderNo" :label="$t('momoLogs.systemOrderNo')">
                    <el-input size="mini" v-model="form.systemOrderNo" />
                </el-form-item>
                <el-form-item prop="partnerId" :label="$t('momoLogs.partnerId')">
                    <el-input size="mini" v-model="form.partnerId" />
                </el-form-item>
                <el-form-item prop="tranid" :label="$t('momoLogs.tranid')">
                    <el-input size="mini" v-model="form.tranid" />
                </el-form-item>
                <!-- <el-form-item prop="createTime" :label="$t('momoLogs.createTime')"> -->
                <!-- <el-date-picker
            type="datetime"
            size="mini"
            v-model="form.createTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          /> -->
                <el-form-item prop="formTime" :label="$t('momoLogs.acktime')">
                    <v-date-picker ref="datePick" v-model="formTime" />
                </el-form-item>
                <!-- </el-form-item> -->
                <!-- <el-form-item prop="comment" :label="$t('momoLogs.comment')">
          <el-input size="mini" v-model="form.comment" />
        </el-form-item> -->

                <el-form-item>
                    <el-button size="mini" type="warning" @click="handleEmpty()">{{
                        $t('btns.empty')
                        }}</el-button>
                    <el-button size="mini" type="primary" @click="handleSearch()">{{
                        $t('btns.search')
                        }}</el-button>
                    <el-button size="mini" type="primary" @click="handleExport()">{{
                        $t('btns.export')
                        }}</el-button>
                </el-form-item>
            </el-form>
        </el-row>

        <el-row>
            <el-table :data="tableList" :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ textAlign: 'center' }" stripe>
                <el-table-column width="280px" prop="merchantOrderNo"
                    :label="$t('momoLogs.merchantOrderNo')"></el-table-column>
                <!-- <el-table-column
          width="280px"
          prop="systemOrderNo"
          :label="$t('momoLogs.systemOrderNo')"
        ></el-table-column> -->
                <el-table-column prop="tranid" :label="$t('momoLogs.tranid')"></el-table-column>
                <el-table-column prop="comment" :label="$t('momoLogs.comment')"></el-table-column>

                <el-table-column prop="user" :label="$t('momoLogs.user')"></el-table-column>
                <el-table-column prop="no" :label="$t('momoLogs.no')"></el-table-column>

                <el-table-column prop="partnerId" :label="$t('momoLogs.partnerId')"></el-table-column>
                <!-- <el-table-column prop="user" :label="$t('momoLogs.user')"></el-table-column>
        <el-table-column prop="partnerName" :label="$t('momoLogs.partnerName')"></el-table-column> -->
                <el-table-column prop="amount" :label="$t('momoLogs.amount')">
                    <template slot-scope="{ row }">
                        {{ row.amount | toThousands }}
                    </template>
                </el-table-column>
                <el-table-column prop="desc" :label="$t('momoLogs.desc')"></el-table-column>
                <el-table-column prop="status" :label="$t('momoLogs.status')"> </el-table-column>
                <el-table-column prop="acktime" :label="$t('momoLogs.acktime')"></el-table-column>
                <el-table-column prop="createTime" :label="$t('momoLogs.createTime')"></el-table-column>
            </el-table>
        </el-row>
        <!-- /* ----------------------------------- 分页 ----------------------------------- */ -->
        <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />

        <el-dialog> </el-dialog>
    </el-card>
</template>

<script>
    import logsApi from '@/api/logs';
    import { debounce } from 'lodash';
    export default {
        name: 'momoLogs',
        data() {
            return {
                dialogVisible: false,
                formTime: [],
                tableData: {},
                form: {},
                pagination: {
                    no: 1,
                    size: this.$defaultPaginationSize
                }
            };
        },
        computed: {
            tableList() {
                return this.tableData.list || [];
            }
        },
        created() {
            this.handleSearch = debounce(this.getTableData, 200);
            this.handleEmpty();
        },
        mounted() {
            this.getTableData();
        },
        methods: {
            handleEmpty() {
                this.form = {
                    tranid: '',
                    comment: '',
                    merchantOrderNo: '',
                    systemOrderNo: '',
                    partnerId: '',
                    createTime: ''
                };
            },

            /* ---------------------------------- 格式化数据 --------------------------------- */
            formatParams() {
                const [startTime, endTime] = this.formTime;
                if (!startTime || !endTime) {
                    // 若用户点击了时间表单的清空，则重新默认选择当天数据
                    this.$refs.datePick.handleTime('today');
                }
                return {
                    ...Object.keys(this.form).reduce(
                        (acc, key) => {
                            if (this.form[key] === 0 || this.form[key]) {
                                acc[key] = this.form[key];
                            }
                            return acc;
                        },
                        { startTime, endTime }
                    )
                };
            },
            async getTableData() {
                const params = {
                    params: this.pagination,
                    data: this.formatParams()
                };
                const { data } = await logsApi.getPage(params);

                if (data) {
                    if (data.code === 200) {
                        this.tableData = data.data;
                    } else {
                        this.$message.error(data.msg);
                    }
                }
            },

            async handleExport() {
                const { data, headers } = await logsApi.doExport(this.formatParams());
                if (data) {
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(data);
                    fileReader.onload = (event) => {
                        // 处理load事件。该事件在读取操作完成时触发
                        // 新建个下载的a标签，完成后移除。
                        let a = document.createElement('a');
                        a.download = `${headers['content-disposition'].split('=')[1]}.xlsx`;
                        a.href = event.target.result;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    };
                } else {
                    this.$message.error(this.$t('status.error'));
                }
            }
        }
    };
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/momo-logs/index.vue